import { connect } from "react-redux";

import {
  searchOpportunityRecommendedAssets,
  searchOpportunitySharedAssets,
} from "src/legacy/redux/actions/search";
import { fetchCRMEnabledIntegration } from "src/legacy/redux/actions/integrations";

import OpportunityRecommendedAssetsView from "./view";

const mapStateToProps = (state, ownProps) => {
  const opportunityId = window.location.pathname.split('/')[3];

  return {
    id: opportunityId,
    recommended: state.legacyRootReducer.search.opportunityRecommendedContents,
    shared: state.legacyRootReducer.search.opportunitySharedContents,
    integration: state.legacyRootReducer.settings.integrations.activated.crmIntegration,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    searchOpportunityRecommendedAssets: (opportunityId) => {
      dispatch(searchOpportunityRecommendedAssets(opportunityId));
    },
    searchOpportunitySharedAssets: (opportunityId) => {
      dispatch(searchOpportunitySharedAssets(opportunityId));
    },
    fetchCRMEnabledIntegration: () => {
      dispatch(fetchCRMEnabledIntegration());
    },
  };
};

const OpportunityRecommendedAssetsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(OpportunityRecommendedAssetsView);

export default OpportunityRecommendedAssetsContainer;